<template>
  <section id="at-a-glance" ref="counterSection" class="at-a-glance container text-center mt-44 max-w-[1340px] mx-auto">
    <h2 class=" responsive-body-large font-semibold leading-6 mb-6">At a glance</h2>
    <p class="responsive-title-3 font-semibold mix-blend-multiply w-full mx-auto max-w-[660px]">
      Cosmos Yachting Worldwide since 1987 in numbers
    </p>

    <!-- First Row with 2-Column Span for the First Item -->
    <div class=" mt-16 mx-auto grid grid-cols-1 md:grid-cols-4 gap-5 max-w-[1340px]">
      <div class="relative bg-cover rounded-12xl min-h-91 text-left text-white overflow-hidden md:col-span-2">
        <img loading="lazy" src="@/assets/about/offices.jpg" class="brightness-70 absolute inset-0 w-full h-full object-cover rounded-12xl" />
        <div class="relative z-10 p-8">
          <h3 class="responsive-title-5">Athens, Munich, London, Seoul</h3>
          <p class="mt-2.5  responsive-body-large">Offices</p>
        </div>
      </div>
      <div class="relative bg-cover rounded-12xl min-h-91 text-left text-white overflow-hidden md:col-span-1">
        <img loading="lazy" src="@/assets/about/yacht_charter_own_yachts.jpg" class="brightness-70 absolute inset-0 w-full h-full object-cover rounded-12xl" />
        <div class="relative z-10 p-8">
          <h3 class="responsive-title-2">{{ glanceDataThree[0].displayValue }}</h3>
          <p class="mt-2.5 responsive-body-large text-white leading-6">Ownership of Yachts between 40ft & 51ft per 2024</p>
        </div>
      </div>
      <div class="relative bg-cover rounded-12xl min-h-91 text-left text-white overflow-hidden">
        <img loading="lazy" src="@/assets/about/yacht_sales_new.png" class="brightness-70 absolute inset-0 w-full h-full object-cover rounded-12xl" />
        <div class="relative z-10 p-8">
          <h3 class="responsive-title-2">{{ glanceDataThree[1].displayValue }}</h3>
          <p class="mt-2.5  responsive-body-large">Yacht Sales New</p>
        </div>
      </div>
    </div>

    <!-- Second Row with 4 Equal Columns -->
    <div class=" mt-7 mx-auto grid grid-cols-1 md:grid-cols-4 gap-5 max-w-[1340px]">
      <!-- First Column -->
      <div class="relative bg-cover rounded-xl min-h-91 text-left text-white overflow-hidden">
        <img loading="lazy" src="@/assets/about/yacht_sales_used.jpg" class="brightness-70 absolute inset-0 w-full h-full object-cover rounded-xl" />
        <div class="relative z-10 p-8">
          <h3 class="responsive-title-2">{{ glanceDataThree[2].displayValue }}</h3>
          <p class="mt-2.5 responsive-body-large">Yacht Sales Used</p>
        </div>
      </div>
      <div class="relative bg-cover rounded-xl min-h-91 text-left text-white overflow-hidden">
        <img loading="lazy" src="@/assets/about/yacht-registration.png" class="brightness-70 absolute inset-0 w-full h-full object-cover rounded-xl" />
        <div class="relative z-10 p-8">
          <h3 class="responsive-title-2">{{ glanceDataThree[3].displayValue }}</h3>
          <p class="mt-2.5  responsive-body-large text-white">Yacht Registrations</p>
        </div>
      </div>

      <!-- Third Column -->
      <div class="relative bg-cover rounded-12xl min-h-91 text-left text-white overflow-hidden">
        <img loading="lazy" src="@/assets/about/yacht_charter_worldwide_as_agency.jpg" class="brightness-70 absolute inset-0 w-full h-full object-cover rounded-12xl" />
        <div class="relative z-10 p-8">
          <h3 class="responsive-title-2">{{ glanceDataThree[4].displayValue }}</h3>
          <p class="mt-2.5 responsive-body-large">Yacht Charters,<br> Worldwide as agency</p>
        </div>
      </div>

      <!-- Fourth Column -->
      <div class="relative bg-cover rounded-xl min-h-91 text-left text-white overflow-hidden">
        <img loading="lazy" src="@/assets/about/yacht_charter_own_yachts.jpg" class=" absolute inset-0 w-full h-full object-cover rounded-xl" />
        <div class="relative z-10 p-8">
          <h3 class="responsive-title-2">{{ glanceDataThree[5].displayValue }}</h3>
          <p class="mt-2.5 responsive-body-large">Yacht Charters Own Yachts, Greece & Turkey</p>
        </div>
      </div>
    </div>

    <!-- Third Row with Custom Width for Large Text -->
    <div class=" mt-7 mx-auto grid grid-cols-1 md:grid-cols-4 gap-5 max-w-[1340px]">
      <!-- First Div -->
      <div class="relative bg-cover rounded-12xl min-h-91 text-left text-white overflow-hidden">
        <img loading="lazy" src="@/assets/about/crewed_charter_megayachts.jpg" class="brightness-70 absolute inset-0 w-full h-full object-cover rounded-12xl" />
        <div class="relative z-10 p-8">
          <h3 class="responsive-title-2">{{ glanceDataThree[6].displayValue }}</h3>
          <p class="mt-2.5 responsive-body-large">Yacht Charters Worldwide Crewed Yachts</p>
        </div>
      </div>
      

      <!-- Third Div -->
      <div class="relative bg-cover rounded-12xl text-left overflow-hidden md:col-span-3 flex flex-col justify-between">
        <img loading="lazy" src="@/assets/about/customers_worldwide.jpg" class="brightness-50 absolute inset-0 w-full h-full object-cover rounded-12xl" />
        <div class="relative z-10 p-8 flex flex-col justify-between h-full">
          <p class="responsive-body-large text-white text-neutral-400">Yacht Buyers, Citizens from</p>
          <p class="mt-6 responsive-title-5 font-semibold text-white">
            Azerbaijan, Australia, Austria, Belgium, Bulgaria, China, Croatia, Denmark, France, Germany, Greece,
            Great Britain, Holland, Israel, Italy, Norway, Portugal, Russia, Switzerland, Spain, Sweden, Serbia,
            South Korea, Taiwan, Turkey, Ukraine, USA
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "AtGlanceSection3",
  data() {
    return {
      glanceDataThree: [
        { value: 37, displayValue: 0 },
        { value: 747, displayValue: 0  },
        { value: 545, displayValue: 0 },
        { value: 980, displayValue: 0 },
        { value: 38600, displayValue: 0 },
        { value: 10500, displayValue: 0 },
        { value: 840, displayValue: 0 },
      ],
      hasAnimated: false, // to prevent multiple triggers
    };
  },
  mounted() {
    if (!this.$refs.counterSection) {
      console.error("counterSection ref not found!");
      return;
    }

    const observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && !this.hasAnimated) {
            this.startCounters();
            this.hasAnimated = true;
            observer.disconnect(); 
          }
        },
        {
          threshold: 0.2, 
        }
    );

    observer.observe(this.$refs.counterSection);
  },
  methods: {
    startCounters() {
      this.glanceDataThree.forEach((item) => {
        this.animateValue(item, 1000); // 1000 ms (1 second) duration for each counter
      });
    },
    animateValue(item, duration) {
      let start = 0;
      const end = item.value;
      const range = end - start;
      const startTime = performance.now();

      const step = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        item.displayValue = Math.floor(start + range * progress).toLocaleString();

        if (progress < 1) {
          requestAnimationFrame(step);
        }
      };

      requestAnimationFrame(step);
    },
  },
};
</script>
